module.exports = __webpack_public_path__ + "static/img/noprize.a46a810.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/noprize.png
// module id = be06
// module chunks = 6